import { TenorFieldData } from 'components/shared/TenorField/TenorField';

export function toCustomizableTenor(value?: unknown): TenorFieldData | undefined {
  if (!value || typeof value !== 'string') {
    return undefined;
  }

  const regex = /^(\d+)\s+(months?|weeks?|days?|years?)$/i;
  const match = value.trim().match(regex);

  if (!match) {
    return undefined;
  }

  const num = parseInt(match[1], 10);
  const unitInput = match[2].toLowerCase();

  let unit: string;
  if (unitInput.startsWith('month')) {
    unit = 'Month';
  } else if (unitInput.startsWith('week')) {
    unit = 'Week';
  } else if (unitInput.startsWith('day')) {
    unit = 'Day';
  } else if (unitInput.startsWith('year')) {
    unit = 'Year';
  } else {
    return undefined;
  }

  return {
    currentValue: { value: num, unit },
    isCustomized: false,
  };
}
